export const CrownIcon = () => (
  <svg
    width="42"
    height="29"
    viewBox="0 0 42 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.38858 8.13719C1.23581 7.29694 2.13863 6.6642 2.87632 7.09452L12.1865 12.5255C12.6435 12.792 13.229 12.6566 13.5224 12.2164L20.168 2.24807C20.5638 1.65434 21.4362 1.65434 21.8321 2.24808L28.4776 12.2164C28.771 12.6566 29.3565 12.792 29.8135 12.5255L39.1237 7.09452C39.8614 6.6642 40.7642 7.29693 40.6114 8.13718L37.1493 27.1789C37.0628 27.6544 36.6487 28 36.1654 28H5.83458C5.35129 28 4.93716 27.6544 4.85071 27.1789L1.38858 8.13719Z"
      stroke-width="2"
    />
  </svg>
);
